export default {
  successTenantTitle: 'Hello {{name}}!',
  successUserTitle: 'Hello {{name}}!',
  successText: 'Your edna Pulse account has been created!',
  linkRequested: 'Your request for a new registration link has been successfully sent',
  setPassword: 'You need to create a password to log into your edna dashboard.',
  createPassword: 'Create password',
  repeatPassword: 'Repeat password',
  yourLogin: 'Your login',
  signIn: 'Sign in',
  acceptTerms: 'By clicking the button you agree to the<br/> <0>user agreement</0>',
  linkExpiredTitle: 'The link is no longer valid',
  linkExpiredText: 'Unfortunately, the 24-hour link has expired',
  requestLinkTitle: 'Request a new registration link and our manager will send it to your email',
  requestLink: 'Repeat request',
  linkAlreadyRequested: 'You have already requested a new registration link',
  wait: 'Please be patient, this may take some time',
  requestLinkText: 'Our manager will notify you once the link has been generated',
  userLinkCancelledTitle: 'Link cancelled',
  userLinkCancelledSubtitle: 'This link can no longer be used for registration.',
  userLinkCancelledDescription: 'If you need access to edna Pulse, please request a new link.',
  userLinkAcceptedTitle: 'This link has already been used.',
  userLinkAcceptedSubtitle:
    'If you don’t have access to edna Pulse yet, please request a new link.',
  selfRegistered: {
    successText: 'Create a password.',
    acceptTerms: 'By registering, you agree to the \n<0>Terms of Service</0>',
    linkAlreadyRequestedTitle: 'A link has been sent to your email',
    linkAlreadyRequestedText: 'A registration link has already been sent to your email.',
    linkExpiredTitle: 'The confirmation link has expired',
    linkExpiredSubtitle: 'Request a new one — it will be sent to your email',
    requestLink: 'Resend',
  },
  unknownError: {
    title: 'Something went wrong',
    text: 'An unexpected error occurred during registration.\n\n' + 'Please try again later.',
  },
};
